// TODO disable on prod
export const logger = console;
